import React from 'react';
import {Link} from 'react-router';
import './LoginSupport.scss';

interface LoginSupportProps {}

export const LoginSupport: React.FC<LoginSupportProps> = () => {
  return (
    <div className="login-support">
      <div className="password-support">
        <Link
          to="https://support.mediafly.com/hc/en-us/categories/9198972474523-Coach360"
          target="_blank">
          Get Support
        </Link>
      </div>
    </div>
  );
};
